import { render, staticRenderFns } from "./PurchaseBlock.vue?vue&type=template&id=53c0ca8e&scoped=true"
import script from "./PurchaseBlock.vue?vue&type=script&lang=js"
export * from "./PurchaseBlock.vue?vue&type=script&lang=js"
import style0 from "./PurchaseBlock.vue?vue&type=style&index=0&id=53c0ca8e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0ca8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c0ca8e')) {
      api.createRecord('53c0ca8e', component.options)
    } else {
      api.reload('53c0ca8e', component.options)
    }
    module.hot.accept("./PurchaseBlock.vue?vue&type=template&id=53c0ca8e&scoped=true", function () {
      api.rerender('53c0ca8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/PurchaseBlock.vue"
export default component.exports